export const GET_PROCEDURE_MANAGERS_REQUEST_SENT =
  'app/ManageProcedureManagers/GET_PROCEDURE_MANAGERS_REQUEST_SENT';
export const GET_PROCEDURE_MANAGERS_REQUEST_SUCCEED =
  'app/ManageProcedureManagers/GET_PROCEDURE_MANAGERS_REQUEST_SUCCEED';
export const GET_PROCEDURE_MANAGERS_REQUEST_FAILED =
  'app/ManageProcedureManagers/GET_PROCEDURE_MANAGERS_REQUEST_FAILED';
